import React, { Component } from 'react';
import { Link, Navigate } from 'react-router-dom';
import { Form, Alert, Button, Container, Row, Col } from 'react-bootstrap';
import './App.css';
import ReCaptcha from './reCAPTCHA';
import { auth, db } from '../firebase'; // Import Firebase config
import { createUserWithEmailAndPassword } from 'firebase/auth'; // Import Firebase Auth methods
import { doc, setDoc } from 'firebase/firestore'; // Import doc and setDoc for Firestore

class Signup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      phone: '',
      email: '',
      password: '',
      confirmPassword: '',
      error: '',
      captchaVerified: false,
      redirectToAccueil: false,
    };
  }

  handleInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  inscrire = async (e) => {
    e.preventDefault();

    const { name, phone, email, password, confirmPassword, captchaVerified } = this.state;

    if (!captchaVerified) {
      this.setState({ error: 'Veuillez compléter le CAPTCHA ._.' });
      return;
    }

    if (password !== confirmPassword) {
      this.setState({ error: 'Les mots de passe ne correspondent pas ._.' });
      return;
    }


    try {
      // Créer un utilisateur avec Firebase Auth
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);

      // Récupérer l'utilisateur et son token
      const user = userCredential.user;
      const token = await user.getIdToken();

      // Afficher les informations de l'utilisateur dans la console
      console.log('Utilisateur créé :', user);
      console.log('Token d\'authentification :', token);

      // Vous pouvez également afficher des informations spécifiques
      console.log('Nom :', user.displayName); // Nom de l'utilisateur (si défini dans Firebase)
      console.log('Email :', user.email);     // Email de l'utilisateur
      console.log('UID :', user.uid);         // UID de l'utilisateur (identifiant unique)

      // Stocker le token dans localStorage
      localStorage.setItem('userToken', token);

      // Enregistrer l'utilisateur dans Firestore
      const userRef = doc(db, "users", user.uid);
      await setDoc(userRef, {
        name,
        email,
        phone,
        uid: user.uid,
      });

      // Rediriger l'utilisateur vers la page d'accueil
      this.setState({ redirectToAccueil: true });
      
    } catch (error) {
      console.error('Erreur lors de l\'inscription de l\'utilisateur:', error);
      this.setState({ error: 'Une erreur est survenue lors de l\'inscription.' });
    }
};


  handleCaptchaChange = (value) => {
    this.setState({ captchaVerified: value });
  };

  render() {
    const { name, phone, email, password, confirmPassword, error, redirectToAccueil } = this.state;

    // Rediriger si l'inscription est réussie
    if (redirectToAccueil) {
      return <Navigate to="/accueil" />;
    }

    return (
      <Container fluid className="d-flex align-items-center justify-content-center min-vh-100 bg-light">
  <Row className="justify-content-md-center">
    <Col style={{ maxWidth: '500px' }} className="box shadow-lg rounded bg-white p-4">
      <div className="text-center">
        <img
          src={`${process.env.PUBLIC_URL}/logoWhite.png`}
          alt="Logo"
          style={{ width: '150px', height: 'auto', marginBottom: '10px' }}
        />
        <h1 style={{ color: '#9caf7d', fontFamily: 'inherit' }}>Sign Up</h1>
      </div>
      <br />
      {error && (
        <Alert
          variant="danger"
          className="text-center"
          style={{
            marginBottom: '20px',
            padding: '10px',
            borderRadius: '10px',
            boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
          }}
        >
          {error}
        </Alert>
      )}
      <Form onSubmit={this.inscrire}>
        <Form.Group className="mb-3" controlId="formBasicName">
          <Form.Control
            type="text"
            placeholder="Nom"
            name="name"
            value={name}
            onChange={this.handleInputChange}
            required
            style={{ borderRadius: '10px', transition: 'all 0.3s ease-in-out' }}
          />
        </Form.Group>

        <Form.Group className="mb-3" controlId="formBasicEmail">
          <Form.Control
            type="email"
            placeholder="Adresse email"
            name="email"
            value={email}
            onChange={this.handleInputChange}
            required
            style={{ borderRadius: '10px', transition: 'all 0.3s ease-in-out' }}
          />
        </Form.Group>

        <Form.Group className="mb-3" controlId="formBasicPhone">
          <Form.Control
            type="tel"
            placeholder="Numéro de téléphone"
            name="phone"
            value={phone}
            onChange={this.handleInputChange}
            required
            style={{ borderRadius: '10px', transition: 'all 0.3s ease-in-out' }}
          />
        </Form.Group>

        <Form.Group className="mb-3" controlId="formBasicPassword">
          <Form.Control
            type="password"
            placeholder="Mot de passe"
            name="password"
            value={password}
            onChange={this.handleInputChange}
            required
            style={{ borderRadius: '10px', transition: 'all 0.3s ease-in-out' }}
          />
        </Form.Group>

        <Form.Group className="mb-3" controlId="formBasicConfirmPassword">
          <Form.Control
            type="password"
            placeholder="Confirmer Mot de passe"
            name="confirmPassword"
            value={confirmPassword}
            onChange={this.handleInputChange}
            required
            style={{ borderRadius: '10px', transition: 'all 0.3s ease-in-out' }}
          />
        </Form.Group>

        <div className="d-grid gap-2">
          <center>
            <ReCaptcha onChange={this.handleCaptchaChange} />
          </center>
          <Button
            style={{
              backgroundColor: '#9caf7d',
              fontFamily: 'inherit',
              border: 'none',
              borderRadius: '10px',
              padding: '10px 20px',
              transition: 'background-color 0.3s ease-in-out',
            }}
            variant="primary"
            type="submit"
          >
            Sign Up
          </Button>
        </div>
      </Form>
      <div className="text-center mt-3">
        Vous avez déjà un compte ? <Link to="/login">Log In</Link>
      </div>
    </Col>
  </Row>
</Container>

    );
  }
}

export default Signup;
